import { useState } from 'react'
import { STRINGS } from '../../utils/strings'
import { CustomButton, FIELD_VALUE_CONSTANTS, FormInput, Modal } from '@ui-kit'
import { BUTTONS, componentNames } from '../../utils/constants'
import { TableViewType } from '../../types/userPreferences.types'

const SaveViewModal = ({
  modal,
  setModal,
  handleSave,
  currentView,
}: {
  modal: { type: string; state: boolean }
  setModal: React.Dispatch<
    React.SetStateAction<{
      type: string
      state: boolean
    }>
  >
  handleSave: (name: string) => Promise<void>
  currentView: TableViewType | undefined
}) => {
  const [name, setName] = useState<string>(
    modal?.type !== BUTTONS.CREATE ? currentView?.name ?? '' : ''
  )
  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event?.target?.value)
  }
  return (
    <div className="modal-non-rounded">
      <Modal
        isOpen={modal.state}
        closeModal={() => setModal({ type: '', state: false })}
        bodyCssClassName="z-[9999] !overflow-hidden [&_.modal-scroll-container]:!overflow-hidden [&_.modal-scroll-container]:!h-auto [&_.modal-scroll-container]:!w-full [&_.modal-body-container]:!h-auto [&_.modal-body-container]:!w-full"
        cssClassName={'z-[9999]'}
        width="w-[32rem]"
        showCloseButton={false}
        isResizable
        minResizeHeight={150}
      >
        <div className="px-[1.125rem] py-[1rem] flex flex-col gap-3 w-full min-w-0">
          <div className="flex justify-between items-center gap-2 min-w-0">
            <span className="flex text-md font-medium leading-[1.125rem] whitespace-nowrap shrink-0">
              {modal?.type === BUTTONS.SAVE_AS
                ? STRINGS.FILTER_VIEW_SAVE_AS
                : STRINGS.FILTER_VIEW_SAVE}
            </span>
            <div className="flex gap-3 items-center justify-end shrink-0 whitespace-nowrap">
              <CustomButton
                onClick={() => setModal({ type: '', state: false })}
                color="primary"
                className="border border-primary-500 text-xs !w-fit"
              >
                <span className="text-xs text-accent-900 font-light">
                  {BUTTONS.CANCEL}
                </span>
              </CustomButton>
              <CustomButton
                onClick={() => {
                  const trimmed = name?.trim()
                  if (!trimmed) return
                  handleSave(trimmed)
                }}
                color="primary"
                isFilled={true}
                disabled={!name?.trim()}
                className="w-fit"
              >
                {BUTTONS.SAVE}
              </CustomButton>
            </div>
          </div>
          <div>
            <FormInput
              name={''}
              label={componentNames.NAME}
              maxLength={FIELD_VALUE_CONSTANTS.FIFTY}
              defaultValue={name}
              onChange={handleNameChange}
              validation={{
                required: true,
              }}
            />
          </div>
          <div className="flex w-full">
            <span className="ml-auto text-xs text-accent-600">
              {STRINGS.CHARACTER_LIMIT_50}
            </span>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default SaveViewModal
